export enum CohortUserRoles {
  MENTOR = 'MENTOR',
  ESTUDIANTE = 'ESTUDIANTE',
  COMENTOR = 'COMENTOR',
}
